import { render, staticRenderFns } from "./EditSubTransportFoamModal.vue?vue&type=template&id=4f5ec059&scoped=true&"
import script from "./EditSubTransportFoamModal.vue?vue&type=script&lang=js&"
export * from "./EditSubTransportFoamModal.vue?vue&type=script&lang=js&"
import style0 from "./EditSubTransportFoamModal.vue?vue&type=style&index=0&id=4f5ec059&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ec059",
  null
  
)

export default component.exports